import { AuthEffects } from './auth.effects';
import { SharedEffects } from './shared.effects';
import { AccountEffects } from './account.effects';
import { AddressEffects } from './address.effects';
import { VoucherEffects } from './voucher.effects';

export const effects: any[] = [
    AuthEffects, 
    SharedEffects, 
    AccountEffects, 
    AddressEffects,
    VoucherEffects
];
